<adaa-item-slider class="my-3" [showPerformance]="showOverall()" [scrollInput]="280" [arrowsInHeader]="true">
    <h5 title class="py-2 agg-perf__title">
        <ng-content></ng-content>
    </h5>

    <!-- The [performance] host stays a static child: Angular resolves projection
         slots at compile time, so a node behind @if falls into the default slot
         and lands inside the scrolling rail instead of the performance panel. -->
    <div performance class="agg-perf__overall d-flex flex-column align-items-center justify-content-center" [class.d-none]="!showOverall()">
        @if (overallAggregationPerf(); as overallPerf) {
            @if (overallPerf.enabled) {
                <adaa-doughnut
                    [size]="'md'"
                    [amount]="overallPerf.value!"
                    [description]="overallPerf | translateToken: 'label'"
                    [colorId]="overallPerf.color!"
                    [colorizeValue]="true"
                    [label]="overallPerf | translateToken: 'label'"
                />

                <button class="btn-primary-faded" (click)="selectedAggregationType.set(overallPerf); openPerformanceGraph(performanceGraphModal)">
                    <fa-icon [icon]="icon.graph" />
                    {{ "common.form.label.performance_comparison" | translate }}
                </button>
            }
        }
    </div>
    @for (aggType of aggregationPerf(); track aggType.id) {
        @if (aggType.enabled) {
            <adaa-aggregation-perf-card
                [data]="aggType"
                [period]="selectedPeriod()"
                (performanceGraphClicked)="selectedAggregationType.set($event); openPerformanceGraph(performanceGraphModal)"
                [hasWeightsProblem]="hasWeightsProblem(aggType.aggregationType, aggType.warningTranslationKey)"
            />
        }
    }
</adaa-item-slider>

<ng-template #performanceGraphModal let-modal>
    <adaa-entity-comparison-modal
        elementId="aggPerformanceChart"
        [title]="chartTitle"
        [entities]="entitiesPerformance()"
        [average]="averagePerformance()?.score"
        [selectedPeriod]="selectedPeriod()"
        [showEntityTypeAndSize]="showEntityTypeAndSize()"
        (filterChanged)="onFilterChange($event)"
        (closed)="modal.dismiss()"
    />
</ng-template>
